export const QUESTION_MATRIX_BIPOLAR_STYLES = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  SLIDER: 'SLIDER',
};

export const COLLAPSIBLE_SELECTOR =
  '.bipolar-vertical-content, .bipolar-vertical-after-image';
export const CLOSED_CLASS = 'bipolar-vertical-collapsible--closed';
